import React from "react";
import { Grid, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../AuthorizationWrapper";

function NumberSetting(props) {
  const [value, setValue] = React.useState(props.setting.value);
  return (
    <AuthorizationWrapper
      permission={props.authenticationName}
      child={(write) => {
        return (
          <>
            <Grid container alignItems={"center"} spacing={1}>
              <Grid item xs={2}>
                <TextField
                  disabled={!write || props.disabled}
                  value={value}
                  type={"number"}
                  inputProps={props.inputProps ?? {}}
                  onKeyPress={(e) => {
                    if (props.inputProps?.min != null) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => setValue(e.target.value)}
                  onBlur={() => {
                    props.onChange(value);
                  }}
                />
              </Grid>
              <Grid item xs={10}>
                <Typography>{props.label}</Typography>
              </Grid>
            </Grid>
            {props.children}
          </>
        );
      }}
    />
  );
}

export default NumberSetting;
